"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/icon.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Ficon.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonIconToJSON = exports.commonIconFromJSON = exports.VectorIcon = exports.IconSource = exports.IconDescriptor = exports.CommonIcon = void 0;
const style_1 = require("./style");
const protobufPackage = 'com.step.render.proto';
/**
 * Well-known icons pre-defined on the client.
 */
var CommonIcon;
(function (CommonIcon) {
    CommonIcon["INVALID_ICON"] = "INVALID_ICON";
    CommonIcon["STEP_ICON"] = "STEP_ICON";
    CommonIcon["CHECK_DEPOSIT_ICON"] = "CHECK_DEPOSIT_ICON";
    CommonIcon["PAY_OVER_TIME_PAYMENT_ICON"] = "PAY_OVER_TIME_PAYMENT_ICON";
    CommonIcon["PAY_OVER_TIME_ICON"] = "PAY_OVER_TIME_ICON";
    CommonIcon["STEP_BLACK_ICON"] = "STEP_BLACK_ICON";
    CommonIcon["STEP_FLEX_CASH_ADVANCE_ICON"] = "STEP_FLEX_CASH_ADVANCE_ICON";
    CommonIcon["STEP_FLEX_CREDIT_LINE_ICON"] = "STEP_FLEX_CREDIT_LINE_ICON";
    CommonIcon["STEP_FLEX_ICON"] = "STEP_FLEX_ICON";
    CommonIcon["CRYPTO_BTC_ICON"] = "CRYPTO_BTC_ICON";
    CommonIcon["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CommonIcon || (exports.CommonIcon = CommonIcon = {}));
function createBaseIconDescriptor() {
    return { source: exports.IconSource.fromPartial({}), style: undefined, border: undefined };
}
exports.IconDescriptor = {
    fromJSON(object) {
        const message = {
            source: isSet(object.source)
                ? exports.IconSource.fromJSON(object.source)
                : exports.IconSource.fromPartial({}),
        };
        if (isSet(object.style)) {
            message.style = style_1.IconStyle.fromJSON(object.style);
        }
        if (isSet(object.border)) {
            message.border = style_1.BorderStyle.fromJSON(object.border);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = exports.IconSource.toJSON(message.source);
        }
        if (message.style !== undefined) {
            obj.style = style_1.IconStyle.toJSON(message.style);
        }
        if (message.border !== undefined) {
            obj.border = style_1.BorderStyle.toJSON(message.border);
        }
        return obj;
    },
    create(base) {
        return exports.IconDescriptor.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIconDescriptor();
        message.source = (object.source !== undefined && object.source !== null)
            ? exports.IconSource.fromPartial(object.source)
            : exports.IconSource.fromPartial({});
        message.style = (object.style !== undefined && object.style !== null)
            ? style_1.IconStyle.fromPartial(object.style)
            : undefined;
        message.border = (object.border !== undefined && object.border !== null)
            ? style_1.BorderStyle.fromPartial(object.border)
            : undefined;
        return message;
    },
};
function createBaseIconSource() {
    return {
        url: undefined,
        urlSet: undefined,
        vectorIcon: undefined,
        text: undefined,
        commonIcon: undefined,
    };
}
exports.IconSource = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.url)) {
            message.url = globalThis.String(object.url);
        }
        if (isSet(object.urlSet)) {
            message.urlSet = globalThis.String(object.urlSet);
        }
        if (isSet(object.vectorIcon)) {
            message.vectorIcon = exports.VectorIcon.fromJSON(object.vectorIcon);
        }
        if (isSet(object.text)) {
            message.text = globalThis.String(object.text);
        }
        if (isSet(object.commonIcon)) {
            message.commonIcon = commonIconFromJSON(object.commonIcon);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.urlSet !== undefined) {
            obj.urlSet = message.urlSet;
        }
        if (message.vectorIcon !== undefined) {
            obj.vectorIcon = exports.VectorIcon.toJSON(message.vectorIcon);
        }
        if (message.text !== undefined) {
            obj.text = message.text;
        }
        if (message.commonIcon !== undefined) {
            obj.commonIcon = commonIconToJSON(message.commonIcon);
        }
        return obj;
    },
    create(base) {
        return exports.IconSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIconSource();
        message.url = object.url ?? undefined;
        message.urlSet = object.urlSet ?? undefined;
        message.vectorIcon = (object.vectorIcon !== undefined && object.vectorIcon !== null)
            ? exports.VectorIcon.fromPartial(object.vectorIcon)
            : undefined;
        message.text = object.text ?? undefined;
        message.commonIcon = object.commonIcon ?? undefined;
        return message;
    },
};
function createBaseVectorIcon() {
    return { name: '' };
}
exports.VectorIcon = {
    fromJSON(object) {
        const message = { name: isSet(object.name) ? globalThis.String(object.name) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.VectorIcon.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVectorIcon();
        message.name = object.name ?? '';
        return message;
    },
};
function commonIconFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ICON':
            return CommonIcon.INVALID_ICON;
        case 1:
        case 'STEP_ICON':
            return CommonIcon.STEP_ICON;
        case 2:
        case 'CHECK_DEPOSIT_ICON':
            return CommonIcon.CHECK_DEPOSIT_ICON;
        case 3:
        case 'PAY_OVER_TIME_PAYMENT_ICON':
            return CommonIcon.PAY_OVER_TIME_PAYMENT_ICON;
        case 8:
        case 'PAY_OVER_TIME_ICON':
            return CommonIcon.PAY_OVER_TIME_ICON;
        case 4:
        case 'STEP_BLACK_ICON':
            return CommonIcon.STEP_BLACK_ICON;
        case 9:
        case 'STEP_FLEX_CASH_ADVANCE_ICON':
            return CommonIcon.STEP_FLEX_CASH_ADVANCE_ICON;
        case 5:
        case 'STEP_FLEX_CREDIT_LINE_ICON':
            return CommonIcon.STEP_FLEX_CREDIT_LINE_ICON;
        case 6:
        case 'STEP_FLEX_ICON':
            return CommonIcon.STEP_FLEX_ICON;
        case 7:
        case 'CRYPTO_BTC_ICON':
            return CommonIcon.CRYPTO_BTC_ICON;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CommonIcon.UNRECOGNIZED;
    }
}
exports.commonIconFromJSON = commonIconFromJSON;
function commonIconToJSON(object) {
    switch (object) {
        case CommonIcon.INVALID_ICON:
            return 'INVALID_ICON';
        case CommonIcon.STEP_ICON:
            return 'STEP_ICON';
        case CommonIcon.CHECK_DEPOSIT_ICON:
            return 'CHECK_DEPOSIT_ICON';
        case CommonIcon.PAY_OVER_TIME_PAYMENT_ICON:
            return 'PAY_OVER_TIME_PAYMENT_ICON';
        case CommonIcon.PAY_OVER_TIME_ICON:
            return 'PAY_OVER_TIME_ICON';
        case CommonIcon.STEP_BLACK_ICON:
            return 'STEP_BLACK_ICON';
        case CommonIcon.STEP_FLEX_CASH_ADVANCE_ICON:
            return 'STEP_FLEX_CASH_ADVANCE_ICON';
        case CommonIcon.STEP_FLEX_CREDIT_LINE_ICON:
            return 'STEP_FLEX_CREDIT_LINE_ICON';
        case CommonIcon.STEP_FLEX_ICON:
            return 'STEP_FLEX_ICON';
        case CommonIcon.CRYPTO_BTC_ICON:
            return 'CRYPTO_BTC_ICON';
        case CommonIcon.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.commonIconToJSON = commonIconToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=icon.js.map